<div class="bg-light card-radius">
    @if (!isLoading) {
        <div class="card" [class.cursor-hand]="clickable">
            <div class="icon-background" [style.backgroundColor]="color | sharedUiColoredBackgroundColor$ | async">
                <div class="icon">
                    @if (iconImage) {
                        <img alt="" [src]="iconImage" />
                    }
                </div>
            </div>
            <div class="content">
                <ng-content />
            </div>
        </div>
    } @else {
        <div class="loader">
            <ui-spinner size="micro" />
        </div>
    }
</div>
